export const storageService = {
  get,
  set,
  remove,
  cacheData,
  getCachedData,
  // Session storage methods
  getSession,
  setSession,
  removeSession,
  clearAllSession,
}

function get(key) {
  const rawData = localStorage.getItem(key)
  return rawData ? JSON.parse(rawData) : null
}

function set(key, value) {
  localStorage.setItem(key, JSON.stringify(value))
}

function remove(key) {
  localStorage.removeItem(key)
}

// Session storage methods
function getSession(key) {
  const rawData = sessionStorage.getItem(key)
  return rawData ? JSON.parse(rawData) : null
}

function setSession(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value))
}

function removeSession(key) {
  sessionStorage.removeItem(key)
}

function clearAllSession() {
  sessionStorage.clear()
}

function cacheData(storageKey, data, expirationTime = 30 * 60 * 1000) {
  set(storageKey, {
    data,
    expirationTime: Date.now() + expirationTime,
  })
}

function getCachedData(storageKey) {
  const cachedData = get(storageKey) || {}

  if (cachedData?.data && isCacheValid(cachedData?.expirationTime)) {
    return cachedData.data
  } else return null
}

function isCacheValid(cacheTimestamp) {
  return !!(Date.now() <= cacheTimestamp)
}
